<template>
  <div>
    <card>
      <Form :model="searchForm" inline >
        <FormItem>
          <Input type="text" v-model="searchForm.keyword" placeholder="姓名/手机号"/>
        </FormItem >
        <FormItem label="课程" :label-width="60">
          <Select v-model="searchForm.course_id" style="width:150px" clearable @on-clear="clearCourse">
            <Option v-for="(item,index) in courseList" :key="index" :value="item.id">{{item.name}}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" size="small" :loading="loading" @click="getTeacherList">
            <span v-if="loading">查询中</span>
            <span v-else>查询</span>
          </Button>
          <Button type="primary" size="small" style="margin-left: 5px;" @click="addTeacher">新增</Button>
        </FormItem>
      </Form>
      <Table :columns="teacherTable.columns" :data="teacherTable.data"></Table>
      <Page :total="pageTotalNum" :current="pageCurrent" v-if="showPager" show-elevator show-total
            @on-change="changePage" :page-size="20" ></Page>
    </card>
  </div>
</template>
<script>
  export default {
    name: 'teacher_index',
    data() {
      return {
        loading: false,
        searchForm: {
          keyword: '',
          course_id: ''
        },
        totalPage:0,
        pageTotalNum:0,
        pageCurrent:1,
        courseList: [],
        teacherTable: {
          columns: [
            {
              title: '姓名',
              key: 'name',
              align: 'center'
            },
            {
              title: '手机号',
              key: 'mobile',
              align: 'center'
            },
            {
              title: '性别',
              key: 'sex',
              align: 'center',
              render:(h,params)=>{
                let self = this
                let opArray = [];
                let flag = ((Number)(params.row.sex) == 1 ? '男' : '女')
                opArray.push(h('div', {}, flag));
                return h('div', opArray);
              }
            },
            {
              title: '课程',
              key: 'course',
              align: 'center'
            },
            {
              title: '备注',
              key: 'remark',
              align: 'center'
            },
            {
              title: '操作',
              align: 'center',
              width: 220,
              render: (h, params) => {
                let self = this;
                let opArray = [];
                opArray.push(h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: 'teacher_detail',
                        query: {
                          id: params.row.id,
                        }
                      })
                    }
                  }
                }, '详情'));
                opArray.push(h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {},
                  on: {
                    click: () => {
                      self.$Modal.confirm({
                        title: '提示',
                        content: '是否确定删除？',
                        onOk: () => {
                          this.$api.teacher.delTeacher({id:params.row.id}).then(res=>{
                            if(res.state=="ok"){
                              this.$Message.success("删除成功")
                              this.getTeacherList();
                            }else{
                              this.$Message.error(res.msg)
                            }
                          })
                        }
                      })
                    },
                    onCancel: () => {
                    }
                  }
                }, '删除'));
                return h('div', opArray);
              }
            }
          ],
          data: []
        }
      }
    },
    mounted() {
      this.getTeacherList()
      this.getCourseList()
    },
    activated() {
      if (this.$route.params.reload) {
        this.getTeacherList()
      }
    },
    methods: {
      getCourseList(){
        this.courseList=[];
        this.$api.teacher.getCourseList().then(res=>{
          if(res.state=="ok")
            this.courseList=res.courseList;
        })
      },
      getTeacherList() {
        this.teacherTable.data=[];
        this.pageTotalNum=0;
        let param={
          page:this.pageCurrent,
          keyword:this.searchForm.keyword,
          course_id:this.searchForm.course_id
        }
        this.$api.teacher.getTeacherList(param).then(res=>{
          if(res.state=="ok"){
            this.pageTotalNum = res.teacherList.totalRow;
            this.totalPage = res.teacherList.totalPage;
            this.pageCurrent = res.teacherList.pageNumber;
            this.teacherTable.data=res.teacherList.list;
          }else{
            this.$Message.error(res.msg)
          }
        })

      },
      changePage (page) {
        this.pageCurrent = page;
        this.getTeacherList();
      },
      clearCourse(){
        this.searchForm.course_id=null
      },
      addTeacher(){
        this.$router.push({
          name: 'teacher_detail',
          query: {
            id: '',
          }
        })
      }
    },
    computed: {
      showPager : function(){
        return this.totalPage > 1
      }
    },
  }
</script>
